import { AudioManager } from "./AudioManager";
import { GameVars } from "./GameVars";

export class Game extends Phaser.Game {

    public static currentInstance: Phaser.Game;

    constructor(config: Phaser.Types.Core.GameConfig) {
        
        super(config);
      
        Game.currentInstance = this;

        this.onBlur = () => {
            if (AudioManager.effects) {
                AudioManager.effects.mute(true);
            }

            if (AudioManager.soundtrack) {
                AudioManager.soundtrack.mute(true);
            }
        };

        this.onFocus = () => {
            if (AudioManager.effects) {
                AudioManager.effects.mute(GameVars.gameData.soundMuted);
            }

            if (AudioManager.soundtrack) {
                AudioManager.soundtrack.mute(GameVars.gameData.soundtrackMuted);
            }
        };
    }
}
